export default __webpack_public_path__ + "static/media/Ladies-Special-.05098a05.jpg";